module.exports = __webpack_public_path__ + "static/media/effect2.014390c4.png";